// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dv-question-title[data-v-a81fc82a]{text-align:center}.dv-question-title .dv-title[data-v-a81fc82a]{text-align:left;width:90%}.sheetMusicCreationMask[data-v-a81fc82a]{position:absolute;left:0;top:0;bottom:0;right:0;background:hsla(0,0%,96.9%,.85);display:flex;justify-content:center;align-items:center;flex-direction:column;z-index:5000}.sheetMusicCreationText[data-v-a81fc82a]{color:#6495ed;font-size:2rem}", ""]);
// Exports
module.exports = exports;
